import React from 'react';
import { ChevronDown } from 'lucide-react';
import { cn } from '../../utils/cn';

export interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  error?: string;
  hint?: string;
}

export const Select = React.forwardRef<HTMLSelectElement, SelectProps>(
  ({ className, id, name, label, error, hint, ...props }, ref) => {
    const reactId = React.useId();
    const selectId = id ?? name ?? reactId;

    return (
      <div className="space-y-1.5">
        {label ? (
          <label htmlFor={selectId} className="block text-sm font-medium text-ink-700">
            {label}
          </label>
        ) : null}
        <div className="relative">
          <select
            ref={ref}
            id={selectId}
            name={name}
            className={cn(
              'min-h-10 w-full appearance-none rounded-lg border bg-white px-3 pr-9 text-sm text-ink-900 transition-colors duration-200',
              'focus:outline-none focus:ring-2 disabled:cursor-not-allowed disabled:bg-ink-50 disabled:text-ink-500',
              error
                ? 'border-danger-100 focus:border-danger-600 focus:ring-danger-100'
                : 'border-ink-300 focus:border-academy-500 focus:ring-academy-100',
              className,
            )}
            {...props}
          />
          <ChevronDown className="pointer-events-none absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2 text-ink-400" />
        </div>
        {error ? (
          <p className="text-sm text-danger-600">{error}</p>
        ) : hint ? (
          <p className="text-sm text-ink-500">{hint}</p>
        ) : null}
      </div>
    );
  },
);

Select.displayName = 'Select';
